import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import {
    Layout,
    Breadcrumb,
    Button,
    Avatar,
    Dropdown,
    Space,
    Typography,
    Flex,
} from "antd";
import {
    ArrowLeftOutlined,
    EditOutlined,
    CopyOutlined,
    DeleteOutlined,
    EllipsisOutlined,
} from "@ant-design/icons";

const { Header, Content } = Layout;
const { Title, Text } = Typography;

export default function DetailPageHero({
    title,
    subtitle,
    breadcrumbs = [],
    avatar,
    onEdit,
    onDelete,
    onCopy,
    actions = [],
    metadata = [],
}) {
    const navigate = useNavigate();

    const initial = (title || "?")
        .toString()
        .trim()
        .charAt(0)
        .toUpperCase();

    const breadcrumbItems = breadcrumbs.map((crumb, index) => ({
        key: `${crumb.label}-${index}`,
        title: crumb.to ? (
            <Link to={crumb.to} className="detail-hero__breadcrumb-link">
                {crumb.label}
            </Link>
        ) : (
            <span className="detail-hero__breadcrumb-current">{crumb.label}</span>
        ),
    }));

    const dropdownItems = [
        ...(onCopy
            ? [
                {
                    key: "copy",
                    icon: <CopyOutlined />,
                    label: "Копировать",
                    onClick: onCopy,
                },
            ]
            : []),
        ...actions.map((action, index) => ({
            key: `action-${index}`,
            icon: action.icon,
            label: action.label,
            onClick: () => action.onClick?.(),
        })),
        ...(onDelete
            ? [
                {
                    key: "delete",
                    icon: <DeleteOutlined />,
                    label: "Удалить",
                    danger: true,
                    onClick: onDelete,
                },
            ]
            : []),
    ];

    const dropdownMenu = dropdownItems.length > 0 ? (
        <div style={{ display: "none" }} />
    ) : null;

    return (
        <Layout className="detail-hero" style={{ background: "transparent", }}>
            {/* <Header style={{ background: "transparent", padding: 0, height: "auto", lineHeight: "normal" }}>
                {breadcrumbs.length > 0 && (
                    <Breadcrumb className="detail-hero__breadcrumbs" items={breadcrumbItems} />
                )}
            </Header> */}

            <Content style={{ background: "transparent", marginTop: 16 }}>
                <Flex justify="space-between" align="flex-start" gap="large" wrap="wrap">
                    <Space size="large" align="start">
                        {/* <Button
                            onClick={() => navigate(-1)}
                            className="detail-hero__back-btn"
                            aria-label="Go back"
                            icon={<ArrowLeftOutlined />}
                            shape="circle"
                        /> */}

                        <Avatar size={56} src={avatar} style={{ backgroundColor: "#1677ff" }}>
                            {!avatar && initial}
                        </Avatar>

                        <div className="detail-hero__info">
                            <Title level={1} className="detail-hero__title" style={{ margin: 0 }}>
                                {title}
                            </Title>
                            {subtitle && <Text type="secondary" className="detail-hero__subtitle">{subtitle}</Text>}
                            {metadata.length > 0 && (
                                <div className="detail-hero__metadata" style={{ marginTop: 2 }}>
                                    {metadata.map((item, index) => (
                                        <span key={index} className="detail-hero__metadata-item">
                                            {item.label && (
                                                <Text type="secondary" className="detail-hero__metadata-label">
                                                    {item.label}:&nbsp;
                                                </Text>
                                            )}
                                            <Text className="detail-hero__metadata-value">{item.value}</Text>
                                        </span>
                                    ))}
                                </div>
                            )}
                        </div>
                    </Space>

                    <Space>
                        {/* {onEdit && (
                            <Button onClick={onEdit} icon={<EditOutlined />} className="detail-hero__action-btn">
                                Редактировать
                            </Button>
                        )} */}

                        {dropdownMenu && (
                            <Dropdown menu={{ items: dropdownItems }} trigger={["click"]}>
                                <Button className="detail-hero__more-btn" icon={<EllipsisOutlined />} />
                            </Dropdown>
                        )}
                    </Space>
                </Flex>
            </Content>
        </Layout>
    );
}

DetailPageHero.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    breadcrumbs: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            to: PropTypes.string,
        })
    ),
    avatar: PropTypes.string,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func,
    onCopy: PropTypes.func,
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.node,
            onClick: PropTypes.func.isRequired,
        })
    ),
    metadata: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.node.isRequired,
        })
    ),
};
